module.exports = __webpack_public_path__ + "components/breakheader/static/surf-alert@2-f751d1c4f4bae52682b7a0359c139eff.png";